if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.#thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.#thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

				// Re-apply color filtering whenever the slider (re)initialises or
				// rebuilds itself (resize / breakpoint change / section reload).

				this.productSlider.addEventListener('ready', ()=>{
					this.#reapplyColorFilter();
				});
				this.productSlider.addEventListener('reset', ()=>{
					if ( ! this._suppressFilterReentry ) {
						this.#reapplyColorFilter();
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.#onVariantChangeHandler.bind(this));
				this.#onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				this._buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				this._buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		disconnectedCallback(){
			if ( this._buyObserver ) {
				this._buyObserver.disconnect();
			}
		}

		#thumbnailNavigationHelper(index=0){
			const allThumbnails = this.querySelectorAll('.product-gallery__thumbnails .thumbnail');
			const visibleThumbnails = [...allThumbnails].filter(elm => ! elm.classList.contains('is-color-hidden'));
			const thumbnails = visibleThumbnails.length ? visibleThumbnails : [...allThumbnails];
			thumbnails.forEach((elm, i)=>{
				if ( i == index ) {
					elm.classList.add('active');
					this.querySelector('.product-gallery__thumbnails-holder').scrollTo({
						left: elm.offsetLeft - 50,
						behavior: 'smooth'
					})
				} else {
					elm.classList.remove('active');
				}
			});
		}

		// --- Variant color image grouping ---------------------------------------
		// Each gallery item carries a `data-color` attribute (parsed from the media
		// alt text "( color: ... )" in snippets/product-media.liquid). When a color
		// is selected we show only the matching images (plus any image with no
		// color tag, treated as shared) and rebuild the slider around them.

		#galleryColors(){
			const colors = new Set();
			if ( this.productGallery ) {
				this.productGallery.querySelectorAll('.product-gallery-item[data-color]').forEach(item=>{
					const color = ( item.dataset.color || '' ).trim().toLowerCase();
					if ( color ) {
						colors.add(color);
					}
				});
			}
			return colors;
		}

		#galleryHasColors(){
			return this.#galleryColors().size > 0;
		}

		#getVariantColor(variant){
			if ( ! variant ) {
				return null;
			}
			const colors = this.#galleryColors();
			if ( ! colors.size ) {
				return null;
			}
			const options = variant.options && variant.options.length
				? variant.options
				: [variant.option1, variant.option2, variant.option3];
			for ( const option of options ) {
				if ( option == null ) {
					continue;
				}
				const value = option.toString().trim().toLowerCase();
				if ( colors.has(value) ) {
					return value;
				}
			}
			return null;
		}

		#reapplyColorFilter(){
			if ( ! this.#galleryHasColors() ) {
				return;
			}
			let color = this._activeColor;
			if ( color === undefined ) {
				if ( ! this.productVariants ) {
					return;
				}
				color = this.#getVariantColor(this.productVariants.currentVariant);
				this._activeColor = color;
			}
			this.#filterGalleryByColor(color, { initial: true });
		}

		#filterGalleryByColor(color, options={}){

			if ( ! this.productGallery ) {
				return;
			}

			const items = this.productGallery.querySelectorAll('.product-gallery-item');

			// Show/hide gallery items by color (items without a color stay visible).
			items.forEach(item=>{
				const itemColor = ( item.dataset.color || '' ).trim().toLowerCase();
				const match = ! color || ! itemColor || itemColor === color;
				item.classList.toggle('is-color-hidden', ! match);
				item.style.display = match ? '' : 'none';
			});

			// Mirror the same visibility on the thumbnails. Thumbnails are rendered
			// in the same media order as the gallery items, so we map them by DOM
			// position and re-index the visible ones to match the slider pages.
			this.#syncThumbnailsToColor(items, color);

			const slider = this.productGallery.querySelector('css-slider');

			if ( slider && slider.sliderEnabled ) {

				this._suppressFilterReentry = true;

				const prefix = slider._prefix || '';
				const selector = ( slider.o && slider.o.selector ) || '.product-gallery-item';

				// Clear stale snap markers on ALL slides (incl. hidden) so the slider
				// rebuilds its pages/navigation only from the visible ones.
				slider.querySelectorAll(selector).forEach(slide=>{
					slide.classList.remove(`${prefix}css-slide--snap`);
				});

				// Restrict the slider to the currently visible slides and rebuild.
				slider.items = this.productGallery.querySelectorAll(`${selector}:not(.is-color-hidden)`);
				slider.resetSlider(true);
				slider.changeSlide(0, 'auto');

				this._suppressFilterReentry = false;

				// Make sure the first visible thumbnail reflects the active slide.
				this.#thumbnailNavigationHelper(0);

			} else {

				// Non-slider layout (e.g. stacked scroll gallery on desktop): just
				// bring the first matching image into view, unless this is the
				// initial render where we must not hijack the page scroll.
				if ( ! options.initial ) {
					const firstVisible = this.productGallery.querySelector('.product-gallery-item:not(.is-color-hidden)');
					if ( firstVisible ) {
						firstVisible.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}
				}
				this.#thumbnailNavigationHelper(0);

			}

		}

		#syncThumbnailsToColor(items, color){
			const thumbnailsHolder = this.querySelector('.product-gallery__thumbnails');
			if ( ! thumbnailsHolder ) {
				return;
			}
			const galleryItems = [...items];
			const thumbnails = [...thumbnailsHolder.querySelectorAll('.thumbnail')];
			let visibleIndex = 0;
			thumbnails.forEach((thumb, i)=>{
				const item = galleryItems[i];
				const itemColor = item ? ( item.dataset.color || '' ).trim().toLowerCase() : '';
				const match = ! color || ! itemColor || itemColor === color;
				thumb.classList.toggle('is-color-hidden', ! match);
				thumb.style.display = match ? '' : 'none';
				if ( match ) {
					thumb.dataset.index = visibleIndex;
					visibleIndex++;
				}
			});
		}

		#focusVariantFeaturedMedia(variant){

			if ( variant.featured_media != null ) {
				let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
				if ( variantImg ) {
					if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
						if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
							this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
						} else {
							this.firstProductGalleryIndex = variantImg.dataset.index;
						}
					} else {
						variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
					}
				}
			}

		}

		#onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				// image handling

				if ( this.#galleryHasColors() ) {
					const color = this.#getVariantColor(variant);
					const isInitial = this._activeColor === undefined;
					if ( color !== this._activeColor ) {
						// Color changed (or first render): regroup the gallery and
						// activate the first image of the selected color.
						this._activeColor = color;
						this.#filterGalleryByColor(color, { initial: isInitial });
					} else {
						// Same color (e.g. size change): just focus the featured media.
						this.#focusVariantFeaturedMedia(variant);
					}
				} else {
					this.#focusVariantFeaturedMedia(variant);
				}

				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
